var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-10",attrs:{"justify":"center"}},[_c('div',{staticClass:"score-table-size"},[_c('ScoreTableRadarChart',{attrs:{"exercise":_vm.dataset}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }